<p-toast #globalToast id="global-toast">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column align-items-center flex-grow-1 w-full overflow-auto">
      <div class="text-lg" *ngIf="message.summary" [innerHtml]="message.summary | safe : 'html'"></div>
      <div class="mt-2 text-center w-full" *ngIf="message.detail" [innerHtml]="message.detail | safe : 'html'"></div>
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog
  #globalConfirmDialog
  rejectButtonStyleClass="p-button-text"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '50vw' }"
>
</p-confirmDialog>

<div *ngIf="!appConfigService.isProduction()" class="environment-display-container">
  {{ appConfigService.getEnvironmentName() }} (version: {{ appConfigService.getBuildName() }}) environment &#64;
  {{ appConfigService.getApiUrl() }}
</div>
<router-outlet> </router-outlet>

<p-toast position="bottom-left" *ngIf="!appConfigService.isLocalDevelopment()" #debugToast id="debug-toast">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column flex-grow-1 w-full overflow-auto">
      <div class="text-lg" *ngIf="message.summary" [innerHtml]="message.summary | safe : 'html'"></div>
      <div class="mt-2 text-center w-full" *ngIf="message.detail" [innerHtml]="message.detail | safe : 'html'"></div>
    </div>
  </ng-template>
</p-toast>
